import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Save, Building } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useCompany } from "@/contexts/CompanyContext";

const Company = () => {
  const { user } = useAuth();
  const { refresh } = useCompany();
  const isAdmin = user?.role === "admin";
  const [form, setForm] = useState({
    name: "", tagline: "", spbu_code: "", address: "", npwp: "", phone: "",
  });

  useEffect(() => {
    api.get("/settings/company").then((r) => setForm((f) => ({ ...f, ...r.data })));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings/company", form);
      await refresh();
      toast.success("Profil perusahaan tersimpan");
    } catch (e) { toast.error("Gagal menyimpan"); }
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Profil Perusahaan</h1>
        <p className="text-sm text-slate-500 mt-1">Nama & identitas perusahaan yang muncul di header, login, dan laporan</p>
      </div>

      <Card>
        <CardHeader><CardTitle className="text-base font-bold flex items-center gap-2"><Building className="w-5 h-5" />Identitas Perusahaan</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={save} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div><Label>Nama Perusahaan</Label>
                <Input value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} required disabled={!isAdmin} data-testid="company-name-input" />
              </div>
              <div><Label>Tagline / Sub-judul</Label>
                <Input value={form.tagline} onChange={(e) => setForm(f => ({ ...f, tagline: e.target.value }))} disabled={!isAdmin} />
              </div>
              <div><Label>Kode SPBU</Label>
                <Input value={form.spbu_code} onChange={(e) => setForm(f => ({ ...f, spbu_code: e.target.value }))} placeholder="34.12304" disabled={!isAdmin} />
              </div>
              <div><Label>NPWP</Label>
                <Input value={form.npwp} onChange={(e) => setForm(f => ({ ...f, npwp: e.target.value }))} placeholder="00.000.000.0-000.000" disabled={!isAdmin} />
              </div>
              <div><Label>Telepon</Label>
                <Input value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} disabled={!isAdmin} />
              </div>
            </div>
            <div><Label>Alamat</Label>
              <Textarea value={form.address} onChange={(e) => setForm(f => ({ ...f, address: e.target.value }))} rows={3} disabled={!isAdmin} />
            </div>
            {isAdmin && (
              <Button type="submit" data-testid="company-save-button" className="bg-[#E30613] hover:bg-[#C8040F]"><Save className="w-4 h-4 mr-2" />Simpan Profil</Button>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Company;
